import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M520-520h292q-12-114-95-198-82-85-197-94v292Zm-80 372v-664q-125 14-210 109-85 96-85 223t85 223q85 95 210 109Zm80 0q115-9 197-94 83-84 95-198H520v292Zm-40-332Zm0 414q-86 0-161-32-76-33-132-89T98-319q-32-75-32-161t32-161q33-76 89-132t132-89q75-33 161-33t162 33q75 33 131 89t89 131q33 75 33 162t-33 162q-33 76-89 131-56 56-131 89-76 32-162 32Z"/>',
  f: '<path d="M520-520v-313q123 12 211 101t102 212H520Zm-80 393q-135-15-224-116-90-102-90-237t90-236q89-102 224-117v706Zm80 0v-313h313q-14 123-102 212-88 90-211 101Z"/>',
};

export default data;
